import { orderBy, whereActive } from './common'
import { collectionGroup, composeQuery, getRootCollection } from './queries'

export const listProducts = () => getRootCollection('products')
export const listPrices = () => collectionGroup('prices')

const stripeMetaData = (key) => `stripe_metadata_${key}`

const whereStripeMetaDataValueFor = (key) => (value) => (query) =>
  query.where(stripeMetaData(key), '==', value)

const whereProductType = whereStripeMetaDataValueFor('productType')
const whereAccountType = whereStripeMetaDataValueFor('accountType')

export const listAvailableSubscriptionPlans = (accountType) =>
  composeQuery(
    listProducts,
    whereActive,
    whereProductType('subscription'),
    whereAccountType(accountType),
    orderBy(stripeMetaData('order'))
  )

export const listActivePrices = () => {
  return composeQuery(listPrices, whereActive)
}
